import { doc, getDocs,getDoc, deleteDoc, collection, and, setDoc ,updateDoc, addDoc, serverTimestamp} from "firebase/firestore";
import { query, where ,or} from "firebase/firestore";

import firebaseObject from "./firebaseinit"
import {getAuth, GoogleAuthProvider,signInWithPopup,setPersistence,browserLocalPersistence, inMemoryPersistence, signOut, onAuthStateChanged} from "firebase/auth"
const db = firebaseObject.db
// // return items

const queries = {
    "category:udemy":query(collection(db, "items"),or(
        where("category", "==", "udemy"),
        where("category", "==", "ml"),
        )
        ) 
}

const selectors = {
    "category": (cat)=>where("category", "==", cat),
    "type": (type)=>where("type", "==", type),
    "isSection": (bool)=>where("isSection", "==", bool)

}


function getItem(callback, docId){
    getDoc(doc(db, "items",docId)).then( q=>{
        let newData =  {...q.data(), id:q.id }
        
        delete newData.timestamp
        callback(newData)
    }).catch(e=>{
        console.log(e)
    })
}

function getAllItems(callback, filters, sort_fil){
    // const ref = doc(firebaseObject.db)
    let querySelectors = Object.keys(filters).map(key=>{
        return selectors[key](filters[key])
    })
    getDocs(query(collection(db, "items"), and(...querySelectors)))
            .then((querySnapshot)=>{        
                let newData = querySnapshot.docs.map((doc) => {
                    return {...doc.data(), id:doc.id }
                }
                    );
                // setTodos(newData);     
                if (sort_fil == "asc"){
                    newData = newData.sort((a,b)=>{
                        if (a.timestamp.seconds > b.timestamp.seconds ) return 1;
                        if (a.timestamp.seconds < b.timestamp.seconds) return -1;
                        return 0;
                    })
                } else if (sort_fil == "desc"){
                    newData = newData.sort((a,b)=>{
                        if (a.timestamp.seconds > b.timestamp.seconds ) return -1;
                        if (a.timestamp.seconds < b.timestamp.seconds) return 1;
                        return 0;
                    })

                }

                callback(newData)
            }).catch(e=>{
                console.log(e)
                callback([])
            })
    
}
let DbService = {
    db: firebaseObject.db,
    getAll: (cb, filter, sort_fil)=>getAllItems(cb, filter, sort_fil),
    getItem: (cb, id)=>getItem(cb, id),
    
}

export default DbService